<template>
	<div/>
</template>

<script>
export default {
	props: {
		selected: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'black'
		},
		selected_color: {
			type: String,
			default: '#00AAFD'
		},
		opacity: {
			type: Number,
			default: 1.0
		}
	},
	computed: {
		fill_color() {
			if (this.selected) {
				return this.selected_color;
			} else {
				return this.color;
			}
		}
	},
	methods: {
		on_click: function() {
			this.$emit('click');
		}
	}
}
</script>